import { PROD_ENV } from './../constants';

const isDevEnv = (): boolean => process.env.NODE_ENV !== PROD_ENV;

export default isDevEnv;
